import MKBox from "components/MKBox";
import { Container, Grid } from "@mui/material";
import Breadcrums from "components/Breadcrumbs";
import routes from "routes";
import footerRoutes from "footer.routes";
import DefaultFooter from "components/Footers/DefaultFooter";
import DefaultNavbar from "components/Navbars/DefaultNavbar";

function IncomeExpenses() {
  return (
    <>
      <MKBox variant="gradient" style={{ backgroundColor: "#344767" }} shadow="sm" py={0.25}>
        <DefaultNavbar routes={routes} transparent relative light right />
      </MKBox>
      <MKBox minHeight="25rem" width="100%">
        <MKBox
          color="black"
          variant="gradient"
          p={1}
          position="relative"
          sx={{
            backgroundColor: "#FFF",
            display: "grid",
            placeItems: "Center",
            backgroundSize: "cover",
          }}
        />
        <MKBox component="section" bgColor="white" py={4}>
          <Container>
            <Grid container spacing={1} item xs={12} lg={12} mx="auto">
              <Grid item xs={4}>
                <Breadcrums
                  routes={[
                    { label: "Inicio", route: "/" },
                    { label: "Vendedores en la Vía Pública", route: "#" },
                    { label: "Vendedores", route: "#" },
                    { label: "Ingresos y gastos", route: "#" },
                  ]}
                />
              </Grid>
            </Grid>
          </Container>
        </MKBox>
        <MKBox
          component="section"
          position="relative"
          variant="contained"
          sx={{
            display: "grid",
            placeItems: "Center",
            backgroundSize: "cover",
            backgroundColor: "#FFF",
            width: "100%",
          }}
        >
          <Container>
            <Grid container height="970px">
              <br />
              <object
                data="https://datastudio.google.com/embed/reporting/60faa881-5d6e-4fb3-b6ff-aff1c4b1162e/page/p_vqyh3obbwc"
                type="application/pdf"
                width="100%"
                height="auto"
              >
                <p>
                  <a href="https://datastudio.google.com/embed/reporting/60faa881-5d6e-4fb3-b6ff-aff1c4b1162e/page/p_vqyh3obbwc">
                    PDF FILE!
                  </a>
                </p>
              </object>
            </Grid>
          </Container>
        </MKBox>
      </MKBox>
      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default IncomeExpenses;
